import { Stack, Text } from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { HorizontalStack } from "../../components/Stack";
import ShareBlackIcon from "../../assets/Icons/svg/shareBlackIcon";
import DragAndDrop from "../../components/DragAndDrop/DragAndDrop";
import SelectDocumentsForSharingModal from "../../components/modals/SelectDocumentsForSharingModal";
import { Document } from "../../models";
import NewShareModal from "../../components/modals/NewShareModal";
import useModal from "../../hooks/useModal";
import CrossIcon from "../../assets/Icons/svg/crossIcon";
import { t } from "i18next";
import { useAppSelector } from "../../hooks/hooks";
import MultipleDownload from "../../components/DownloadPopup/MultipleDownload/MultipleDownload";
import { FILE_BAR_HEIGHT, FILE_BAR_ROW_HEIGHT } from "./documentBarDimensions";

const DragAndDropComp = (props: any) => {
  const [selectedDocuments, setSelectedDocuments] = useState<Document[]>([]);
  const [selectedDocumentsForDownload, setSelectedDocumentsForDownload] = useState<Document[]>([]);
  const [shareDetails, setShareDetails] = useState({});
  const [isMultipleDownloadPopupOpen, setIsMultipleDownloadPopupOpen] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const showMultipleDownloadPopup = () => setIsMultipleDownloadPopupOpen(true);
  const hideMultipleDownloadPopup = () => setIsMultipleDownloadPopupOpen(false);

  const documentVersions = useAppSelector(
    (state) => state.fetchDocumentWithVersions.documents
  );
  const projectState = useAppSelector(
    (state: { fetchProjectDetails: any }) => state.fetchProjectDetails
  );
  // DEX-573 M4: read the shared project-documents slice that DocsInProject already
  // populates, instead of issuing a second GET /documents/{projectId}/root here.
  const projectDocumentsSlice = useAppSelector(
    (state: { fetchProjectDocuments: any }) => state.fetchProjectDocuments
  );
  const projectDocuments: Document[] = Array.isArray(projectDocumentsSlice?.data)
    ? projectDocumentsSlice.data
    : [];

  const handleUploadSuccess = useCallback(
    (fileNames: string[], versionRootDocIds: number[]) => {
      // The shared slice is refreshed by DocsInProject's upload-refresh effects.
      props?.onUploadSuccess?.(fileNames, versionRootDocIds);
    },
    [props?.onUploadSuccess]
  );

  useEffect(()=>{
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  },[projectState])

  useEffect(() => {
    var arr: Document[] = [];
    selectedDocuments.forEach((document) => {
      var filteredData = documentVersions.filter(
        (docVerions: any) =>
          docVerions?.rootDocumentName === document?.rootDocumentName
      );
      var len = filteredData[0]?.versions?.length;
      for (var i = 0; i < len; i += 1) {
        if (filteredData[0]?.versions[i]?.fileType === "received") {
          arr.push(filteredData[0]?.versions[i]);
          break;
        }
      }
    });

    arr.sort((doc1, doc2) => {
      const date1 = new Date(doc1?.lastUpdatedDate!);
      const date2 = new Date(doc2?.lastUpdatedDate!);
      return date2.getTime() - date1.getTime();
    });
    if (arr.length) setShareDetails(arr[0]?.shareDetails!);
  }, [selectedDocuments]);

  const Images = () => {
    let array = Array.from(selectedDocuments);
    return (
      <HorizontalStack
        style={{
          position: "relative",
          backgroundColor: "",
          width: array.length > 3 ? "40%" : "35%",
          marginRight: "5%",
          height: "100%",
          alignItems: "center",
        }}
      >
        {array.slice(0, 5).map((str, index) => {
          return (
            <Stack
              key={index}
              style={{ position: "absolute", left: index * 10 }}
            >
              <img src={require("../../assets/doc.png")} key={index} />
            </Stack>
          );
        })}
      </HorizontalStack>
    );
  };
  const { isModalOpen, showModal, hideModal } = useModal();
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const showShareModal = () => setIsShareModalOpen(true);
  const hideShareModal = () => setIsShareModalOpen(false);
  const ShareComp = () => {
    return (
      <div>
        <HorizontalStack style={styles.shareContainer}>
          <HorizontalStack style={styles.imageWrapper}>
            <Images />
            <Text style={styles.circle}>{selectedDocuments.length}</Text>
          </HorizontalStack>
          <Text style={styles.shareButton} onClick={() => showModal()}>
            {t("continue")}
          </Text>
          <div onClick={() => setSelectedDocuments([])}>
            <CrossIcon />
          </div>
        </HorizontalStack>
      </div>
    );
  };

  return (
    <Stack
      style={{
        // height: docsData.length !== 0 ? "calc(55px + 40px)" : "12rem",
        height: "100%",
        justifyContent: "space-between",
      }}
      className="ProjectDragAndDrop"
    >
      <Stack
        className="DragWrapper"
      >
        <DragAndDrop
          direction={props?.created}
          folderName={props?.folderName}
          refresh={props?.refresh}
          data={projectDocuments}
          projectId={props?.projectId}
          showModal={props?.showImportModal}
          hideModal={props?.hideImportModal}
          isModalOpen={props?.isImportModalOpen}
          rootDocumentId={props?.rootDocumentId}
          setRootDocumentId={props?.setRootDocumentId}
          dropZoneText={typeof projectState.data?.name === 'string' ? projectState.data.name : ""}
          onUploadSuccess={handleUploadSuccess}
        />
      </Stack>

      {projectDocuments.length > 0 && (
        <>
          <HorizontalStack
            style={{ maxHeight: FILE_BAR_HEIGHT }}
            onClick={() => showMultipleDownloadPopup()}
            className="filesDragAndDrop"
          >
            <HorizontalStack
                style={{
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  height: FILE_BAR_ROW_HEIGHT,
                }}
              >
                <HorizontalStack
                  style={{
                    width: "100%",
                    // justifyContent: "center",
                    justifyContent: screenWidth < 850 ? "flex-start" : "center",
                    backgroundColor: "",
                    height: "100%",
                    alignItems: "center",
                    paddingLeft: screenWidth < 850 ? "10px" : "0px",
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24" fill="none">
                    <path d="M23 15.6667V17.1333C23 19.1869 23 20.2136 22.6004 20.998C22.2488 21.6879 21.6879 22.2488 20.998 22.6004C20.2136 23 19.1869 23 17.1333 23H6.86667C4.81314 23 3.78638 23 3.00203 22.6004C2.31211 22.2488 1.75118 21.6879 1.39964 20.998C1 20.2136 1 19.1869 1 17.1333V15.6667M18.1111 9.55556L12 15.6667M12 15.6667L5.88889 9.55556M12 15.6667V1" stroke="#323232" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <Text
                      style={{ color: "#323232", fontSize: "14px", fontWeight: "400", lineHeight: "16px", marginLeft: "13px", cursor: "pointer", fontFamily: "Poppins" }}
                    >
                    Download
                  </Text>
              </HorizontalStack>
            </HorizontalStack>
            <MultipleDownload
              isModalOpen={isMultipleDownloadPopupOpen}
              hideModal={hideMultipleDownloadPopup}
              showModal={showMultipleDownloadPopup}
              selectedDocuments={selectedDocumentsForDownload}
              setSelectedDocuments={setSelectedDocumentsForDownload}
            />
          </HorizontalStack>

          <HorizontalStack
            style={{ maxHeight: FILE_BAR_HEIGHT }}
            className="filesDragAndDrop"
            onClick={() => {
              if (selectedDocuments.length === 0) {
                showModal();
              }
            }}
          >
            <HorizontalStack
              style={{
                width: "100%",
                alignItems: "center",
                justifyContent:
                  selectedDocuments.length > 0 ? "space-between" : "center",
                height: FILE_BAR_ROW_HEIGHT,
              }}
            >
              <HorizontalStack
                style={{
                  width: selectedDocuments.length > 0 ? "40%" : "100%",
                  justifyContent: screenWidth < 850 ? "flex-start" : (selectedDocuments.length > 0 ? "space-evenly" : "center"),
                  backgroundColor: "",
                  height: "100%",
                  alignItems: "center",
                  paddingLeft: screenWidth < 850 ? "10px" : "0px",
                }}
              >
                <ShareBlackIcon />
                <HorizontalStack
                  style={{
                    width: selectedDocuments.length > 0 ? "80%" : "auto",
                  }}
                >
                  <Text style={styles.drag}>{t("share")}</Text>
                </HorizontalStack>
              </HorizontalStack>
              {selectedDocuments.length > 0 && <ShareComp />}
            </HorizontalStack>
            <SelectDocumentsForSharingModal
              isModalOpen={isModalOpen}
              showModal={showModal}
              hideModal={hideModal}
              selectedDocuments={selectedDocuments}
              setSelectedDocuments={setSelectedDocuments}
              showShareModal={showShareModal}
            />
            <NewShareModal
              projectId={props?.projectId}
              isModalOpen={isShareModalOpen}
              hideModal={hideShareModal}
              selectedDocuments={selectedDocuments}
              setSelectedDocuments={setSelectedDocuments}
              shareDetails={shareDetails}
            />
          </HorizontalStack>
        </>
      )}
    </Stack>
  );
};

export default DragAndDropComp;
const styles = {
  filesDragAndDrop: {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    cursor: "pointer",
    height: "100%",
    padding: "10px",
    alignItems: "center",
    width: "49%",
    justifyContent: "space-between",
    border: `1px solid #DAE0EC`,
    // transition: "border-color 0.3s ease",
    "&:hover": {
      borderColor: "black",
    },
  },
  drag: {
    color: "#323232",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "16px",
    marginLeft: "12px",
    fontFamily: "Poppins",
  },
  browse: {
    color: "#007CFF",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "16px",
    textDecorationLine: "underline",
    marginLeft: "1%",
  },
  shareContainer: {
    // width: "55%",
    // justifyContent: "space-between",
    gap: "15px",
    backgroundColor: "",
    alignItems: "center",
    height: "100%",
  },
  imageWrapper: {
    height: "100%",
    alignItems: "center",
    width: "50%",
    backgroundColor: "",
    gap: "49px",
  },
  shareButton: {
    display: "flex",
    width: "106px",
    height: `${FILE_BAR_ROW_HEIGHT}px`,
    padding: "0px 32px",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    borderRadius: "4px",
    background: "#18468F",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "18px",
    color: "#ffffff",
    fontFamily: "Poppins",
  },
  circle: {
    height: "24px",
    width: "48px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #18468F",
    marginLeft: "5%",
    backgroundColor: "#ffffff",
    color: "#18468F",
  },
};
